var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-warp"},[_c('Top-Nav',{attrs:{"pageTitle":"试题详情"},on:{"click-left":_vm.pageBack}}),_c('div',{staticClass:"main-content"},[(_vm.questionDetailData)?_c('Question-item',{attrs:{"questionItem":_vm.questionDetailData,"questionTagOptions":_vm.questionTags}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }